import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Data } from '@angular/router';
import { SubSink } from 'subsink';
import { map, filter, mergeMap, tap } from 'rxjs/operators';
import { LoggerService } from '../../logger';
import { merge } from 'rxjs';

@Component({
  selector: 'lib-breadcrumb',
  styles: [],
  template: `
    <div class="page-breadcrumb" *ngIf="!pageInfo?.hideBreadcrumb">
      <div class="d-md-flex align-items-center">
        <h3 class="page-title">{{ pageInfo?.title }}</h3>
        <div class="ml-auto">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <ng-template
                ngFor
                let-url
                [ngForOf]="pageInfo?.urls"
                let-last="last"
              >
                <li
                  class="breadcrumb-item"
                  *ngIf="!last"
                  [routerLink]="url.url"
                >
                  <a [routerLink]="url.url">{{ url.title }}</a>
                </li>
                <li class="breadcrumb-item active" *ngIf="last">
                  {{ url.title }}
                </li>
              </ng-template>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  `,
})
export class BreadcrumbComponent implements OnDestroy {
  private subs = new SubSink();

  pageInfo: Data | undefined;

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    logger: LoggerService
  ) {
    this.subs.sink = merge(
      activatedRoute.url,
      router.events.pipe(filter((event) => event instanceof NavigationEnd))
    )
      .pipe(
        map(() => activatedRoute.root),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        this.pageInfo = data;
      });
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
